"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderBySum = exports.CompatibleOrderBySumConfig = void 0;
const _ = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./utils");
const getComparableValue = (field) => (loanTape) => {
    const value = (0, utils_1.getFieldValue)({ loanTape, field });
    return _.isNumber(value) ? value : _.toString(value);
};
class CompatibleOrderBySumConfig {
    config;
    operation = 'orderBySum';
    // Private instance properties allow typescript to ensure that an instance of
    // this class is being used.
    constructor(config) {
        this.config = config;
        this.config = config;
    }
    ensureCompatibility = (loanTape) => {
        const { type, groupBy } = this.config;
        const invalidRecord = _.find(loanTape, (record) => {
            const value = (0, utils_1.getFieldValue)({ loanTape: record, field: groupBy });
            return !_.isNil(value) && typeof value !== type;
        });
        (0, common_1.finleyAssert)(!invalidRecord, (0, utils_1.getInvalidFieldTypeMessage)({
            invalidRecord,
            field: groupBy,
            type,
            operationType: this.operation,
        }));
    };
    static create = (config, loanTape) => {
        const obj = new CompatibleOrderBySumConfig(config);
        obj.ensureCompatibility(loanTape);
        return obj;
    };
}
exports.CompatibleOrderBySumConfig = CompatibleOrderBySumConfig;
/*
 * groups loanTapes by groupBy and orders them by
 * the sum of their borrowing base amount. Then selects
 * the loan tapes in the first N groups
 *
 * example config:
 * {
 *    operation: 'orderBySum',
 *    field: 'borrowingBaseAmount',
 *    groupBy: 'industry',
 *    count: 1,
 *    offset: 1
 * }
 *
 */
const orderBySum = ({ config: { groupBy, field, count, offset }, }) => (loanTapeRecords) => {
    return (0, remeda_1.pipe)(loanTapeRecords, (0, remeda_1.filter)((0, utils_1.propertyIsNotNil)(groupBy)), (0, remeda_1.groupBy)(getComparableValue(groupBy)), remeda_1.values, (0, remeda_1.sortBy)([
        (receivables) => _.sumBy(receivables, (receivable) => {
            return (0, utils_1.getFieldValue)({ loanTape: receivable, field });
        }),
        'desc',
    ]), (0, remeda_1.drop)(offset || 0), (0, remeda_1.take)(count), (0, remeda_1.flatten)());
};
exports.orderBySum = orderBySum;
//# sourceMappingURL=orderBySum.js.map